<template>
  <EModal class="rating-feedback-modal" v-bind="$attrs" v-on="$listeners">
    <!-- <EFeedbackForm v-bind="$props" @success="onSuccess" /> -->
    <transition name="toggle">
      <div v-if="!isSubmitted">
        <div class="rating-feeback-text-container">
          <div
            class="rating-feeback-icon"
            :class="ratingIconClass[rating]"
          >
            <EIcon :icon="ratingIcon[rating]" size="s" />
          </div>
          <span class="rating-feeback-header-text">Tell us more</span>
        </div>
        <div class="rating-feeback-text-container rating-feeback-body-text">
          How might we improve this information?
        </div>
        <div class="rating-feeback-input-container">
          <ETextarea
            v-model="message"
            autoscale
          />
          <div class="rating-feeback-input-btn-container">
            <EButton variant="solid-green" size="s" @click="submit">
              Submit feedback
            </EButton>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="isSubmitted">
      <div class="thankyou__wrapper">
        <EIcon icon="check-circle" size="m" />
        <EHeading as="h3" class="thankyou__heading">
          {{ $t('web.green.satisfactionfeedback.submitted.headline') }}
        </EHeading>
      </div>
      <p>
        {{ $t('web.green.satisfactionfeedback.submitted.text') }}
      </p>
    </div>
  </EModal>
</template>

<script>
import EModal from '~~/common/vue/components/modal';
import ETextarea from '~~/common/vue/components/textarea';
import EButton from '~~/common/vue/components/button';
import EIcon from '~~/common/vue/components/icon';
import {
  greenGuideRatingFeedback,
} from '~~/search/common/js/client/analytics/green-guide';

export default {
  name: 'ERatingFeedbackModal',
  components: {
    EModal,
    ETextarea,
    EButton,
    EIcon,
  },
  props: {
    rating: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSubmitted: false,
      message: '',
    };
  },
  computed: {
    ratingIcon() {
      return {
        'thumb-up': 'thumb-up-success',
        'thumb-down': 'thumb-down-error',
      };
    },
    ratingIconClass() {
      return {
        'thumb-up': 'rating-feeback-icon--success',
        'thumb-down': 'rating-feeback-icon--error',
      };
    },
    ratingsValue() {
      return {
        'thumb-up': '1',
        'thumb-down': '0',
      };
    },
  },
  methods: {
    submit() {
      this.$track(greenGuideRatingFeedback(this.message, this.ratingsValue[this.rating]));
      this.isSubmitted = true;
      this.$emit('rating-feedback-submitted');
    },
  },

};
</script>

<style lang="scss">
.rating-feeback-text-container {
  height: $space-3l;
  display: flex;
  align-items: center;

  span {
    margin-left: $space-s;
  }
}

.rating-feeback-header-text {
  font-size: $font-2l;
  font-weight: $font-weight-1l;
}

.rating-feeback-body-text {
  font-size: $font-l;
  font-weight: $font-weight-m;
}

.rating-feeback-icon {
  height: $space-2l;
  width: $space-2l;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &--success {
    background-color: #5dd25e52;
  }

  &--error {
    background-color: #af173152;
  }
}

.rating-feeback-input-container {
  margin-top: $space-1s;
}

.rating-feeback-input-btn-container {
  margin-top: $space-m;
  display: flex;
  justify-content: flex-end;
}

.thankyou__wrapper {
  display: flex;
  align-content: center;
  align-items: center;
  // color: green;
}

.thankyou__heading {
  font-size: $font-1l;
  font-weight: $font-weight-1l;
  color: var(--color-text-primary);
  margin-left: $space-2s;
}
</style>
